import { z } from "zod";

const REGION_CODES = ["EU", "NA", "ASIA"] as const;

export const registerSchema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required")
    .max(30, "First name must be 30 characters or fewer"),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .max(30, "Last name must be 30 characters or fewer"),
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email("Enter a valid email address")
    .max(100, "Email must be 100 characters or fewer"),
  telephone: z
    .string()
    .min(1, "Telephone number is required")
    .regex(
      /^\+?[\d\s\-().]{7,20}$/,
      "Enter a valid phone number (e.g. +1 555 123 4567)",
    ),
  company: z
    .string()
    .min(1, "Company name is required")
    .max(100, "Company name must be 100 characters or fewer"),
  companyAddress: z.string().min(1, "Company address is required"),
  departmentId: z
    .union([z.number().int().positive(), z.string().min(1)])
    .transform((v) => (typeof v === "string" ? parseInt(v, 10) : v))
    .refine((v) => Number.isInteger(v) && v > 0, {
      message: "Please select a department",
    }),
  regionCode: z.enum(REGION_CODES, { message: "Please select a region" }),
});

export type RegisterFormData = z.infer<typeof registerSchema>;
